
class CapViewDistrict {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_district'
}

function create(config) {
  return new CapViewDistrict(config)
}

export default {
  key,
  create,
}
